import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSDMSubmittal, updateSDMQuotation } from 'src/_helpers/api';

const name = 'sdmSubmittals';

const initialState = {
  sdmSubmittals: [],
  error: null,
};

const addSDMSubmittalAsync = createAsyncThunk(`${name}/add-sdm-submittal`, async (submittalData, { rejectWithValue }) => {
  try {
    const response = await createSDMSubmittal(submittalData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSubmittalAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const updateSDMSubmittalAsync = createAsyncThunk(`${name}/update-sdm-submittal`, async (submittalData) => {
  console.log('🚀 ~ submittalData:', submittalData)
  return await updateSDMQuotation(submittalData)
})

const sdmSubmittalSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.sdmSubmittals = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSDMSubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addSDMSubmittalAsync.fulfilled, (state, action) => {
        state.sdmSubmittals.push(action.payload);
      })
      .addCase(addSDMSubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(updateSDMSubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(updateSDMSubmittalAsync.fulfilled, (state, action) => {
        const index = state.sdmSubmittals.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.sdmSubmittals[index] = action.payload;
      })
      .addCase(updateSDMSubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const sdmSubmittalActions = {
  ...sdmSubmittalSlice.actions,
  addSDMSubmittalAsync,
  updateSDMSubmittalAsync,
};

export const sdmSubmittalsReducer = sdmSubmittalSlice.reducer;
